<template lang="pug">
  .student-center-success-container
    .approve
      .beijing(v-if="info&&info.college") {{info.college}}
      img(src='https://m.hellobike.com/resource/AppPlatformH5/base-success/DbZno99b7GmDCGqALbf6n.svg')
      .approce-success 认证成功

    .down.clearfix
      .gain 您获得APP学生特权
      .open 打开哈啰APP 激活尊享学生特权
      .student-card
        .student-card-top
          img(
            src="https://m.hellobike.com/resource/AppPlatformH5/base-success/egWNBqv4YLmPFxmDVQpIa.svg"
          )
          span.ride 学生专享骑行卡
        .price
          span.span1 ¥
          span.span2 9.9
          span.start 起
          span.span3 / 30
          span.span4 天
        .before-price
          del 原价25元
        .allowance 学生专享补贴15.1元
      .ticket-container
        .ticket-wrapper(v-for="item in biz")
          .ticket
            img.ticket-top(:src="item.icon")
            .ticket-middle {{ item.name }}
            .ticket-bottom {{ item.desc }}
      .rule.flex-mid(@click="goRule")
        span 活动规则
        .common-arrow-right
      .bottom-father
        .bottom(@click="goApp") 去哈啰APP领取
</template>

<script>
import Toast from '@/components/toast';
import { getCommonConfig } from '@/api/card';
import { env, Native } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { getTokenAndKey } from '../../utils';
import {
  getPort, getStudentAuthInfo, giveAwayAward, shouldGiveAwayAward,
} from './utils';
import { BIZ } from './consts';

export default {
  data() {
    return {
      info: null,
      biz: BIZ,
    };
  },
  created() {
    UBT.pageView({
      pageId: 'alip_student_ok',
      categoryId: 'platform',
      businessInfo: {
        adsource: this.$route.query.adsource,
        port: getPort(),
      },
    });
  },
  async mounted() {
    getStudentAuthInfo().then((info) => { this.info = info; });
    const { success } = this.$route.query;
    if (success && Number(success) === 1) {
      const { token } = await getTokenAndKey();
      const { student } = await getCommonConfig({ token }).then((v) => v.data).catch(() => ({}));
      if (student && student.modal) {
        shouldGiveAwayAward(student.modal).then((ok) => {
          if (ok) {
            giveAwayAward(student.modal)
              .catch((e) => Toast.showError(e));
          }
        });
      }
    }
  },
  methods: {
    goRule() {
      window.location.href = 'http://h.c3x.me/11dFcv';
    },
    goApp() {
      UBT.clickButton({
        pageId: 'alip_student_ok',
        buttonName: 'go_APP',
        categoryId: 'platform',
        businessInfo: {},
      });
      const to = 'https://m.hellobike.com/ebike-h5/latest/index-3.html#/activity/common?guid=30119a6f22b74638b243483aabf3a73a&beyondMP=true';
      if (env.isAliMP || env.isAliMPMonitor) {
        Native.callNative({
          method: 'goOperationUrlV2',
          params: to,
        });
      } else {
        window.location.href = to;
      }
    },
  },

};
</script>

<style lang="less" scoped>
.student-center-success-container {
  height: 100%;
  overflow-y: auto;

  .approve {
    width: 100%;
    height: 1.52rem;
    background-image: url('https://m.hellobike.com/resource/AppPlatformH5/base-success/5sEljE4UbZ6uoFmv0rUWr.png');
    position: relative;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    overflow: hidden;

    .beijing {
      position: absolute;
      top: 0.27rem;
      right: 0.08rem;
      height: 0.17rem;
      font-size: 0.12rem;
      font-weight: 500;
      color: #fff;
      line-height: 0.17rem;
    }

    img {
      width: 0.39rem;
      height: 0.39rem;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 0.35rem;
    }

    .approce-success {
      width: 100%;
      height: 0.25rem;
      position: absolute;
      top: 0.87rem;
      font-size: 0.18rem;
      font-weight: 500;
      color: #fff;
      line-height: 0.25rem;
      text-align: center;
    }
  }

  .clearfix::before,
  .clearfix::after {
    content: '';
    display: table;
  }

  .clearfix::after {
    clear: both;
  }

  .down {
    margin-top: -0.18rem;
    width: 100%;
    height: 5.82rem;
    background: #fff;
    border-radius: 0.1rem;
    position: relative;

    .gain {
      width: 100%;
      height: 0.28rem;
      font-size: 0.2rem;
      font-weight: 500;
      color: #3e4fff;
      line-height: 0.28rem;
      margin-top: 0.22rem;
      text-align: center;
    }

    .open {
      width: 100%;
      height: 0.17rem;
      font-size: 0.12rem;
      font-weight: 400;
      color: #828282;
      line-height: 0.17rem;
      margin-top: 0.01rem;
      margin-bottom: 0.16rem;
      text-align: center;
    }

    .rule {
      font-size: 0.12rem;
      color: #879099;
      margin-top: 0.04rem;

      .common-arrow-right {
        border-color: #879099;
      }
    }

    .student-card {
      width: 3.44rem;
      height: 1.48rem;
      margin: 0 auto;
      background-image: url("https://m.hellobike.com/resource/AppPlatformH5/base-success/T857Ag8d5p_dFxZ2q6AeC.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: relative;

      .student-card-top {
        width: 0.15rem;
        position: absolute;

        img {
          position: absolute;
          left: 0.21rem;
          top: 0.18rem;
          width: 0.15rem;
          height: 0.13rem;
        }

        .ride {
          height: 0.18rem;
          font-size: 0.13rem;
          position: absolute;
          left: 0.41rem;
          top: 0.15rem;
          font-weight: 600;
          color: #fff;
          white-space: nowrap;
          text-shadow: 0 0 0 rgba(0, 119, 255, 0.38);
        }
      }

      .price {
        position: absolute;
        left: 0.17rem;
        top: 0.78rem;
        width: 1.07rem;
        height: 0.48rem;
        text-align: center;
        color: #fff;
        text-shadow: 0 0 0 rgba(2, 160, 225, 0.65);

        .span1 {
          position: absolute;
          top: 0.2rem;
          left: 0.05rem;
          font-size: 0.16rem;
          font-weight: 500;
        }

        .start {
          font-size: 0.12rem;
          font-weight: 600;
          color: #fff;
          position: absolute;
          top: 0.24rem;
          left: 0.64rem;
          line-height: 0.17rem;
          text-shadow: 0 0 0 rgba(2, 160, 225, 0.65);
        }

        .span2 {
          position: absolute;
          top: 0.01rem;
          left: 0.17rem;
          margin-left: 0.01rem;
          font-size: 0.4rem;
          font-family: "DIN Alternate Bold", sans-serif;
        }

        .span3 {
          position: absolute;
          top: 0.2rem;
          left: 0.78rem;
          white-space: nowrap;
          font-size: 0.2rem;
          font-family: "DIN Alternate Bold", sans-serif;
        }

        .span4 {
          position: absolute;
          top: 0.25rem;
          left: 1.11rem;
          font-size: 0.12rem;
        }
      }

      .before-price {
        position: absolute;
        left: 1.46rem;
        top: 0.85rem;
        height: 0.14rem;
        font-size: 0.1rem;
        font-weight: 400;
        color: #5ec4fe;
        line-height: 0.14rem;
      }

      .allowance {
        position: absolute;
        left: 1.46rem;
        top: 1.01rem;
        width: 1.15rem;
        height: 0.18rem;
        text-align: center;
        font-size: 0.11rem;
        border-radius: 0.09rem;
        color: #fff;
        border: 0.01rem solid #fff;
      }
    }

    .ticket-container {
      overflow-y: hidden;
      width: 100%;
      padding-right: 0.24rem;
      margin-top: 0.2rem;
      padding-left: 0.24rem;

      &::-webkit-scrollbar {
        display: none;
        width: 0;
        height: 0;
        color: transparent;
      }

      .ticket-wrapper {
        width: 33%;
        display: inline-flex;

        &:nth-of-type(3n+1) {
          justify-content: flex-start;
        }

        &:nth-of-type(3n+2) {
          justify-content: center;
        }

        &:nth-of-type(3n) {
          justify-content: flex-end;
        }
      }

      .ticket {
        position: relative;
        height: 0.7rem;
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 0.16rem;
        margin-bottom: 0.16rem;

        .ticket-top {
          width: 0.32rem;
          height: 0.32rem;
        }

        .ticket-middle {
          font-size: 0.13rem;
          font-weight: 500;
          color: #242729;
          line-height: 0.18rem;
          margin-top: 4px;
          margin-bottom: 2px;
        }

        .ticket-bottom {
          font-size: 0.11rem;
          color: #879099;
          line-height: 0.16rem;
        }
      }
    }

    .bottom-father {
      width: 100%;
      padding: 0 0.51rem;
      position: fixed;
      bottom: 0.32rem;

      .bottom {
        width: 100%;
        height: 0.48rem;
        background: linear-gradient(180deg, #57c7fe 0%, #08f 100%);
        box-shadow:
          0 0.01rem 0 0 rgba(37, 37, 37, 0.17),
          0 0.01rem 0.02rem 0 rgba(218, 253, 255, 0.79);
        border-radius: 0.24rem;
        font-size: 0.16rem;
        text-align: center;
        line-height: 0.48rem;
        color: #fff;
      }
    }
  }
}
</style>
